import { Controller } from "@hotwired/stimulus"

// Two-column layout where the shorter column waits at the bottom of the screen
// while the taller one scrolls, then the whole page carries on. The shorter
// column is made sticky with a top offset of (viewport height - its own height),
// so it pins when its bottom edge reaches the bottom of the viewport. If it is
// shorter than the viewport it simply pins below the site header.
export default class extends Controller {
  static targets = ["column"]
  static values = { breakpoint: { type: Number, default: 992 }, headerOffset: { type: Number, default: 88 }, gap: { type: Number, default: 16 } }

  connect() {
    this.update = this.update.bind(this)
    this.observer = new ResizeObserver(this.update)
    this.columnTargets.forEach((column) => this.observer.observe(column))
    window.addEventListener("resize", this.update)
    this.update()
  }

  disconnect() {
    this.observer?.disconnect()
    window.removeEventListener("resize", this.update)
    this.columnTargets.forEach((column) => this.release(column))
  }

  update() {
    if (!window.matchMedia(`(min-width: ${this.breakpointValue}px)`).matches || this.columnTargets.length < 2) {
      this.columnTargets.forEach((column) => this.release(column))
      return
    }

    const [shorter, taller] = [...this.columnTargets].sort((a, b) => a.offsetHeight - b.offsetHeight)
    const top = Math.min(this.headerOffsetValue, window.innerHeight - shorter.offsetHeight - this.gapValue)
    shorter.style.position = "sticky"
    shorter.style.top = `${Math.round(top)}px`
    this.release(taller)
  }

  release(column) {
    column.style.position = ""
    column.style.top = ""
  }
}
